<template>
    <div class="bg-white py-10 sm:py-16">
        <Container>
            <dl class="grid grid-cols-1 gap-6 text-center sm:grid-cols-3">
                <Card v-for="stat in stats" :key="stat.id" class="mx-auto flex w-full max-w-xs flex-col gap-y-2">
                    <dd class="order-first text-4xl font-bold tracking-tight text-primary-600 sm:text-5xl">{{
                        stat.value }}</dd>
                    <dt class="text-base text-gray-600">{{ stat.name }}</dt>
                </Card>
            </dl>
        </Container>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Container from '@/components/ui/Container.vue';
import Card from '@/components/ui/Card.vue';

const stats = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/stats');
    stats.value = response.data.data;
});
</script>
